<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-6 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/vessel-certificates"
          ></back-button>
          Add Vessel Certificate
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-6 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/vessel-certificates`"
              >Vessel Certificates</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <vessel-certificate-form :form="form"></vessel-certificate-form>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import VesselCertificateForm from "./vessel-certificate-form.vue";

export default {
  components: { VesselCertificateForm },
  name: "OfficeJobSchedulerCreate",
  data() {
    return {
      form: {
        vessel_id: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        let vessel_certificate = await axios.post(
          "/vessel_certificates",
          this.form
        );
        this.vessel_certificate = vessel_certificate.data.data;
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/planned-maintenance/vessel-certificates");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.isLoading = true;
      let attachment = this.$refs.file?.files[0];
      const id = this.vessel_certificate.id;

      let formData = new FormData();
      formData.append("id", id);
      formData.append("attachment", attachment);

      await axios
        .post("upload_vessel_certificate_attachment", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      if (this.career_request) {
        this.success = true;
        this.form = [];
      }
      this.isLoading = false;
    },
  },
};
</script>
